var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSproutsNav = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 21,
  fill: "none",
  viewBox: "0 0 16 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.194 4.337C3.625 3.639 7.244 1.919 7.42.764s.479 1.819.55 2.339a3.72 3.72 0 0 1-.924 2.967c-.363.418-1.448 1.01-1.448 1.01S3.625 7.942.5 9.803c0 0-.736-1.998-.42-3.028.327-1.02.684-1.74 2.115-2.437M1 12.113l7.578-4.45a4.73 4.73 0 0 1 3.58-.5A4.62 4.62 0 0 1 15 9.354l-7.578 4.45a4.73 4.73 0 0 1-3.58.499A4.62 4.62 0 0 1 1 12.112M13.806 16.663c-1.431.697-5.05 2.418-5.225 3.572-.175 1.155-.479-1.818-.55-2.338a3.72 3.72 0 0 1 .924-2.968c.363-.418 1.448-1.01 1.448-1.01s1.972-.86 5.098-2.722c0 0 .736 1.999.42 3.029-.327 1.02-.684 1.74-2.115 2.437"
})));
export { SvgSproutsNav as ReactComponent };
export default __webpack_public_path__ + "c25aa4a8c0d37daa00ad8b9ff3967f35.svg";